import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { CommonService } from '../common.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard2Service implements CanActivate, CanActivateChild {

  constructor(private commonServiceService: CommonService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    return this.checkFirstRegistration(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  checkFirstRegistration(url: string) {
    if (this.commonServiceService.isFirstRegistrationDone()) {
      return true;
    }

    this.commonServiceService.redirectUrl = url;

    this.router.navigate(['/registration']);
  }
}
